import { useQuery } from '@tanstack/react-query'
import { adminApi } from '@/api/admin'

/** Polls the server's "N of M" while certificates are being issued for a booking. */
export function useIssueProgress(bookingId: string | null | undefined, active: boolean) {
  const { data } = useQuery({
    queryKey: ['issue-certificates-progress', bookingId],
    queryFn: () => adminApi.getIssueCertificatesProgress(bookingId!),
    enabled: active && !!bookingId,
    refetchInterval: active ? 1000 : false,
    gcTime: 0,
  })
  return active ? data ?? null : null
}

/** Determinate once the server reports a total; otherwise an animated bar (completing, or progress unavailable). */
export function IssueProgressBar({ progress, idleLabel = 'Completing booking…' }: {
  progress: { done: number; total: number } | null
  idleLabel?: string
}) {
  const known = progress !== null && progress.total > 0
  const pct = known ? Math.round((progress.done / progress.total) * 100) : 0
  return (
    <div className="space-y-1.5" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={known ? pct : undefined}>
      <p className="text-sm text-gray-700">
        {known ? `Generating certificates — ${progress.done} of ${progress.total} done` : idleLabel}
      </p>
      <div className="h-2 w-full rounded-full bg-gray-100 overflow-hidden">
        {known ? (
          <div className="h-full rounded-full bg-indigo-600 transition-all duration-500" style={{ width: `${Math.max(pct, 4)}%` }} />
        ) : (
          <div className="h-full w-1/3 rounded-full bg-indigo-400 animate-pulse" />
        )}
      </div>
    </div>
  )
}
